import { DateTimePicker } from '@mui/x-date-pickers';

export const MyDateTimePicker = ({ ...props }) => {
	return (
		<DateTimePicker
			label={props.label}
			allowSameDateSelection
			ampmInClock={false}
			// minutesStep={15}
			ampm={false}
			showTodayButton
			showToolbar
			maxDate={props.maxDate}
			hideTabs
			format='dd/MM/yy HH:mm'
			sx={{ margin: 0, marginTop: 2, padding: 0, minWidth: 184, maxWidth: 184 }}
			slotProps={{
				popper: {
					sx: {
						zIndex: 130000000, // or whatever value you need
					},
				},
			}}
			{...props}
		/>
	);
};
